/**
 * HomepageAnnouncements.jsx
 * Created by michaelbray on 9/25/18.
 */

import React from 'react';
import Cookies from 'js-cookie';

import { ANNOUNCEMENT_PROPS, ANNOUNCEMENT_DEFAULT_PROPS } from '../constants';

import Announcement from '../../sharedComponents/Announcement';
import DisplayHtmlContent from '../../sharedComponents/DisplayHtmlContent';

const propTypes = {
    announcement: ANNOUNCEMENT_PROPS
};

const defaultProps = {
    announcement: ANNOUNCEMENT_DEFAULT_PROPS
};

export default class HomepageAnnouncements extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            hideBannerUponClose: false
        };
    }

    closedAnnouncement = () => {
        // Set a cookie to hide this announcement in the future
        if (this.state.hideBannerUponClose) {
            Cookies.set(this.props.announcement.banner_key, 'hide', { expires: 730 });
        }
    }

    handleCheckboxChange = () => {
        this.setState((prevState) => ({
            hideBannerUponClose: !prevState.hideBannerUponClose
        }));
    }

    render() {
        const announcement = this.props.announcement;

        // Don't show the banner if it's not enabled
        // Don't show the banner on non-homepage pages if the flag is set
        // Don't show the banner on the page the banner button links to
        if (!announcement.banner_enabled
            || (announcement.banner_homepage_only && window.location.pathname !== '/')
            || (announcement.banner_link && announcement.banner_link === window.location.pathname)) {
            return null;
        }

        // Set the default display of the banner to light text with no background box
        // on the body content of the banner
        let textColor = "light";
        let backgroundColor = "";

        // Use dark text, if specified
        if (announcement.banner_body_color === "dark") {
            textColor = "dark";
        }

        // Use a dark or light box around the body content, if specified
        // Otherwise, don't use a box
        if (announcement.banner_background_color === "dark") {
            backgroundColor = "dark";
        }
        else if (announcement.banner_background_color === "light") {
            backgroundColor = "light";
        }

        let decodedBannerBody = "";
        try {
            decodedBannerBody = decodeURIComponent(announcement.banner_body)
        }
        catch (e) {
            console.error(e);
            decodedBannerBody = "";
        }

        return (
            <Announcement
                image={{ backgroundImage: `url(${process.env.CDN}${announcement.banner_image})` }}
                title={announcement.banner_title}
                sticky
                textColor={textColor}
                background={backgroundColor}
                name={announcement.banner_key}
                closedAnnouncement={this.closedAnnouncement}>

                { /* The banner_body is URI-encoded HTML */ }
                <DisplayHtmlContent html={decodedBannerBody} />

                { /* Show a button below the body that links to a page if both the
                    button link and the button title are specified */ }
                {announcement.banner_link && announcement.banner_link_button_title &&
                    (
                    <a
                        href={announcement.banner_link}
                        className="rec-announcement-link-btn"
                        title={announcement.banner_link_button_title}
                        aria-label={announcement.banner_link_button_title}>
                        {announcement.banner_link_button_title}
                    </a>
                    )
                }

                { /* Show a checkbox that allows the user to permanently hide the
                    banner if this flag is enabled */ }
                {announcement.banner_enable_hiding &&
                    (
                    <div className="rec-form-check-wrap">
                        <label htmlFor={announcement.banner_key} className="rec-label-checkbox">
                            <input
                                className="rec-input-hide"
                                type="checkbox"
                                id={announcement.banner_key}
                                name={announcement.banner_key}
                                onChange={this.handleCheckboxChange} />
                            <span className="rec-input-checkbox" />
                            Don&#39;t show me this again
                        </label>
                    </div>
                    )
                }
            </Announcement>
        );
    }
}

HomepageAnnouncements.propTypes = propTypes;
HomepageAnnouncements.defaultProps = defaultProps;
